import React from "react";
import "./table-skeleton.css";
import { TableColumn } from "../../types";

// Table skeleton component props interface
export interface TableSkeletonProps {
  columns: TableColumn[];
  rowCount?: number;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({
  columns,
  rowCount = 5,
}) => {
  return (
    <div className="custom-table">
      <table>
        <thead>
          <tr>
            <th key="index-column" className="skeleton-cell skeleton-header">
              <div className="skeleton-text"></div>
            </th>
            {columns.map((column) => (
              <th key={column.key} className="skeleton-cell skeleton-header">
                <div className="skeleton-text"></div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array(rowCount)
            .fill(0)
            .map((_, rowIndex) => (
              <tr key={`skeleton-row-${rowIndex}`}>
                <td key={`index-column-${rowIndex}`} className="skeleton-cell">
                  <div className="skeleton-text"></div>
                </td>
                {columns.map((column) => (
                  <td
                    key={`${column.key}-${rowIndex}`}
                    className="skeleton-cell"
                  >
                    <div className="skeleton-text"></div>
                  </td>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSkeleton;
